<template>
  <div>
    <b-row class="heading-container">
      <b-col>
        <h4>
          {{ $t("notification_center") | startcase }}
          ({{ notificationsCount }})
        </h4>
      </b-col>
    </b-row>
    <b-row class="justify-content-between">
      <b-col cols="4">
        <form-field
          :placeholder="$t('search') | capitalize"
          v-model="search"
          debounce="1000"
          :icon="['fas', 'search']"
        />
      </b-col>
      <b-col cols="8" class="d-flex justify-content-end align-items-center">
        <b-form-checkbox v-model="showReadNotifications" false="outline-secondary" switch>
          {{ $t("show_read_notifications") | capitalize }}
        </b-form-checkbox>
        <b-button
          :disabled="!notificationsList.length"
          class="ml-3 btn-outline-red"
          @click="markAllAsRead()"
        >
          {{ $t("mark_all_as_read") | capitalize }}
        </b-button>
      </b-col>
    </b-row>
    <div v-for="(notification, index) in notificationsList" :key="`notification-${index}`">
      <Notification
        :key="notification.id"
        :notification="notification" 
        @update-notifications="getData"
      />
    </div>
    <table-pagination
      class="mt-3"
      v-model="page"
      :total-rows="notificationsCount"
      :per-page="perPage"
    />
  </div>
</template>

<script>
import Notification from "./Notification"
import { getPerPageItemDefaults } from "@/constants"
import { listRouteMixin } from "@/utils/mixins"
import { mapActions } from "vuex"

export default {
  name: "NotificationCenter",
  mixins: [listRouteMixin],
  components: { Notification },
  data () {
    return {
      search: "",
      notificationsList: [],
      notificationsCount: 0,
      page: 1,
      limit: Number(getPerPageItemDefaults(this.$route)),
      isNotificationsLoading: false,
      perPage: Number(getPerPageItemDefaults(this.$route)),
      filters: {
        search: { value: "", defaultValue: "" },
      },
      showReadNotifications: false, 
    }
  },
  methods: {
    ...mapActions("actionTabs", ["setUserActionCount"]),
    responseAdapter (data) {
      if (data){
        this.notificationsList = data.data.results
        this.notificationsCount = data.data.count
      }
    },
    async getData () {
      this.isNotificationsLoading = true
      let response = await this.$api.notifications.notificationsList({ ...this.$route.query })
      this.responseAdapter(response)
      this.isNotificationsLoading = false
    },
    markAllAsRead () {
      this.$api.notifications.markAllRead().then(() => {
        this.getData()
        this.setUserActionCount("notificationActionsCount", 0)
      })
    },
  },
  watch: {
    search (value) {
      this.changeFilter("search", value)
      this.applyFilters()
    },
    page (value) {
      this.onPagination(value)
      this.getData()
    },
    perPage: {
      handler (value) {
        this.updateRouterPagination("limit", value)
      },
      immediate: true
    },
    showReadNotifications (value) {
      if (value) {
        this.changeFilter("read", "true")
      } else {
        this.changeFilter("read", "false")
      }
      this.applyFilters()
    }
  },
  mounted () {
    this.changeFilter("read", "false")
    this.getData()
  },
  unmounted () {
    this.resetFilters()
  },
}
</script>
